import gql from 'graphql-tag'

export const GET_PAPER_GROUP = gql`
query ($id: ID!) {
  paperGroup (id: $id) {
    id
    name
    width
    paperSize
    height
    condition
    canvas
  }
}
`

export const GET_PAPER_GROUPS = gql`
  query getPaperGroups (
    $first: Int
    $after: String
    ) {
    paperGroups (
      first: $first
      after: $after
    ) {
      pageInfo {
        endCursor
        hasNextPage
      }
      nodes {
        id
        name
      }
    }
  }
`

export const GET_PAPERGETSIZE = gql`
  query {
    paperGetSize
  }
`

export default {
  GET_PAPER_GROUP,
  GET_PAPER_GROUPS,
  GET_PAPERGETSIZE
}
